import styled from 'styled-components';
import {getSpacing} from '@tickchak/react-share/app';
import {dFlexColumn} from '../../../globalVariables/GlobalFlex';

export const suggestionsStack = styled.div`
    ${dFlexColumn}
    gap: ${getSpacing('spaceMd')};
    flex-shrink: 0;
    margin: auto 0;
`;
